module.exports = __webpack_public_path__ + "static/article-1-2eb65e46a21b3c5feb65f1a32ad60ec7.png";